/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBakingClassTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBakingClass,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Bake Together!",
    "Sweet Treats Await!",
    "Bake Off Fun!",
  ],
  title: "Baking Class",
  description: "Organize a fun baking class.",
  longDescription:
    "Gather your friends for a delightful baking class! Choose a date, decide on recipes to bake, and plan the decorations!",
  emoji: "🍰",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Baking Class",
          emoji: "🍰",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the baking class?",
          emoji: "📅",
          completeAction: {
            question: "Decide on recipes to bake?",
            description: "What recipes should we choose for the class?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What recipes should we bake?",
                emoji: "🍪",
                completeAction: {
                  question: "Decide on decorations?",
                  description:
                    "What decorations should we have for our baking class?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What decorations should we use?",
                      emoji: "🎈",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Baking!",
    outroDescription:
      "Your baking class plans are set! Enjoy making sweet treats!",
  },
};
